export default {
  // orders_summary: (state) => state.orders_summary,
  // orders: (state) => state.orders,
  fulfillment_orders_schedule: (state) => state.fulfillment_orders_schedule,
};
